<div class="viewer-draw d-flex flex-column">
  <h2 class="sr-only">Available Tools</h2>
  <span class="align-self-center viewer-draw-label">Writing</span>
  <div class="viewer-draw-buttons" [ngbTooltip]="tooltipText">
    <zbp-button-component id="penToolButton"
            type="button"
            [ariaLabel]="penIsActive ? 'Pen, Enabled' : 'Pen'"
            [disabled]="!enabled"
            (click)="setActiveTool('draw')"
            [theme]="penIsActive ? 'primary' : 'blackText'"
            [iconName]="zbpIconNames.pencilDrawIcon">
    </zbp-button-component>
    <zbp-button-component id="eraserToolButton"
            type="button"
            [ariaLabel]="eraserIsActive ? 'Erase, Enabled' : 'Erase'"
            [disabled]="!enabled"
            (click)="setActiveTool('erase')"
            [theme]="eraserIsActive ? 'primary' : 'blackText'"
            [iconName]="zbpIconNames.eraserIcon">
    </zbp-button-component>
  </div>
</div>
